import React, { memo } from 'react';

const Filterbar = ({
    memoizedActiveCategories,
    memoizedActiveTags,
    availableCategories,
    availableTags,
    setTagsParam,
    setCategoriesParam,
}) => {
	const isActiveParam = (value, group) => {
		if (group === 'category') return memoizedActiveCategories.includes(value);
		if (group === 'tag') return memoizedActiveTags.includes(value);
		return false;
  };

    const handleParamClick = (value, group) => {
        if (group === 'category')
			setCategoriesParam(value);
        if (group === 'tag')
			setTagsParam(value);
    };

    const getParamLabels = (group) => {
		if (group === 'category') {
			const sortedCategories = availableCategories.sort((a, b) => {
				 const nameA = Object.values(a)[0];
				 const nameB = Object.values(b)[0];
				 if (nameA.startsWith('K')) return -1;
				 if (nameB.startsWith('K')) return 1;
				 if (nameA.startsWith('E')) return -1;
				 if (nameB.startsWith('E')) return 1;
				 if (nameA.startsWith('M')) return -1;
				 if (nameB.startsWith('M')) return 1;
				 return 0;
			});

			return sortedCategories.map((category) => ({
				 value: category,
				 name: Object.values(category)[0],
				 active: memoizedActiveCategories.includes(category),
			}));
	  }
        if (group === 'tag') {
            return availableTags.map((tag) => ({
                value: tag,
                name: Object.values(tag)[0],
            }));
        }
    };

    const handleTagClass = (isActive) => (isActive ? 'tag filter--active agenda-filter--active' : 'tag');

    return (
        <div className="agenda-filter">
            <div role="region" aria-label="Filter type" className="agenda-filter__type">
                {getParamLabels('tag').map((param, index) => {
                    const active = isActiveParam(param.value, 'tag');
                    return (
                        <button
                            key={index}
                            onClick={() => handleParamClick(param.value, 'tag')}
                            className={`${handleTagClass(active)} tag tag--orange`}
                            aria-pressed={active}
                            data-filter={param.name}
                        >
                           <span dangerouslySetInnerHTML={{ __html: param.name }}></span>
                        </button>
                    );
                })}
            </div>
            <div role="region" aria-label="Filter sector" className="agenda-filter__sector">
                {getParamLabels('category').map((param, index) => {
                    const active = isActiveParam(param.value, 'category');
                    return (
                        <button
                            key={index}
                            onClick={() => handleParamClick(param.value, 'category')}
                            className={`${handleTagClass(active)} category tag--blue`}
                            aria-pressed={active}
                            data-filter={param.name}
                        >
                            <span dangerouslySetInnerHTML={{ __html: param.name }}></span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default memo(Filterbar);
